module.exports = __webpack_public_path__ + "img/logo-vodafone.dd4e2495.svg";